import React from 'react'

import { PricedIssuersTable } from './PricedIssuersTable'

interface DashboardIssuersProps {}

export const DashboardIssuers: React.FC<DashboardIssuersProps> = () => {
  return <PricedIssuersTable header={'Priced Issuers'} />
}
